import { encodedTexturePatterns } from '../assets/texturesBase64';
import { texturePatternIdsByTextureIndex } from './consts';
import { css } from 'styled-components';

export const CSS_PATTERN_STRIPES_WIDE = css`
  background-image: url('${encodedTexturePatterns.STRIPES_WIDE}');
  background-size: 180px 36px;
  background-repeat: repeat;
`;

export const CSS_PATTERN_HEXAGONS = css`
  background-image: url('${encodedTexturePatterns.HEXAGONS}');
  background-size: 156px 36px;
  background-repeat: repeat;
`;

export const CSS_PATTERN_STRIPES_CLOSE = css`
  background-image: url('${encodedTexturePatterns.STRIPES_CLOSE}');
  background-size: 180px 36px;
  background-repeat: repeat;
`;

export const CSS_PATTERN_DOTS = css`
  background-image: url('${encodedTexturePatterns.DOTS}');
  background-size: 180px 36px;
  background-repeat: repeat;
`;

export const CSS_PATTERN_WOVEN = css`
  background-image: url('${encodedTexturePatterns.WOVEN}');
  background-size: 180px 36px;
  background-repeat: repeat;
`;

export const getTextureAsCSS = (index: number) => {
  const textureIndex =
    index > texturePatternIdsByTextureIndex.length
      ? index % (texturePatternIdsByTextureIndex.length + 1)
      : index;

  switch (textureIndex) {
    case 1:
      return CSS_PATTERN_STRIPES_WIDE;
    case 2:
      return CSS_PATTERN_HEXAGONS;
    case 3:
      return CSS_PATTERN_STRIPES_CLOSE;
    case 4:
      return CSS_PATTERN_DOTS;
    case 5:
      return CSS_PATTERN_WOVEN;
    default:
      return css``;
  }
};
